import { Star, Users } from "lucide-react";
import type { Game } from "../../data/games";
import { GameArtwork } from "../GameArtwork/GameArtwork";
import styles from "./FeaturedGameCard.module.css";

interface FeaturedGameCardProps {
  game: Game;
  priority?: boolean;
  onSelect: (game: Game, trigger: HTMLButtonElement) => void;
}

export function FeaturedGameCard({
  game,
  priority = false,
  onSelect,
}: FeaturedGameCardProps) {
  const handleSelect = (event: React.MouseEvent<HTMLButtonElement>) => {
    onSelect(game, event.currentTarget);
  };

  return (
    <button
      className={styles.card}
      type="button"
      aria-label={`Öppna detaljer för ${game.title}`}
      onClick={handleSelect}
    >
      <GameArtwork
        imageUrl={game.imageUrl}
        title={game.title}
        fallbackLabel={game.fallbackLabel}
        categoryId={game.categoryId}
        priority={priority}
      />

      <span className={styles.content}>
        <span className={styles.category}>{game.category}</span>
        <span className={styles.title}>{game.title}</span>
        <span className={styles.description}>{game.description}</span>
        <span className={styles.metadata}>
          <span>
            <Star aria-hidden="true" fill="currentColor" />
            {game.rating.toLocaleString("sv-SE", {
              minimumFractionDigits: 1,
            })}
          </span>
          <span>
            <Users aria-hidden="true" />
            {game.minPlayers}–{game.maxPlayers} spelare
          </span>
        </span>
      </span>
    </button>
  );
}
